
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.532 11.025l-8.03 7.621a2.04 2.04 0 01-2.885-.076 2.25 2.25 0 01.083-3.172l6.94-6.586","stroke":"#747272","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.452 11.609l7.01-6.652a4.308 4.308 0 016.073.159c1.574 1.659 1.555 4.43-.097 5.998l-7.072 6.726","stroke":"#747272","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.995 16.521l-5.453 5.174c-2.57 2.44-6.669 2.332-9.108-.238-2.44-2.57-2.332-6.67.239-9.109l4.673-4.435","stroke":"#747272","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    